import { Studio } from "@/api/Studio";
import { Content } from "pdfmake/interfaces";
import { borderBottom, noBorder } from '../../pdfStyles';

const createDeckblattContent = (
  studio: Studio,
  documentTitle: string,
  anzahlBeschaeftigungstageSteuerpflichtig: number,
  anzahlBeschaeftigungstage: number
): Content[] => {
  const gesamtSteuer = "" + (anzahlBeschaeftigungstageSteuerpflichtig * 25);
  return [
  { text: "Betreiber / in:", style: "h2", margin: [0, 15, 0, 20] },
  {
    layout: "solidHorizontalLines",
    margin: [0, -5, 20, 5],
    table: {
      widths: ["*"],
      headerRows: 0,
      keepWithHeaderRows: 0,
      body: [
        [{ text: "Jens Prüfer", style: "tableText" }],
        [
          {
            text: "(Name, Vorname)",
            style: "small",
          },
        ],
        [
          {
            text: /*studio.anschrift || */ "Am Sandacker 13, 64295 Darmstadt",
            style: "tableText",
          },
        ],
        [
          {
            text: "(Wohnanschrift)",
            style: "small",
          },
        ],
        [
          {
            text: "ZNA Zimmerbetreibergesellschaft mbH",
            style: "tableText",
          },
        ],
        [
          {
            text: "(Betrieb, Objekt)",
            style: "small",
          },
        ],
      ],
    },
  },
  {
    text: documentTitle,
    style: "h1",
    alignment: "center",
    margin: [0, 30, 18, 30],
  },
  {
    text: "Berechnung:",
    style: "h1u",
    margin: [0, 15, 0, 5],
  },
  {
    layout: "dottedBorders",
    margin: [0, -5, 20, 5],
    table: {
      widths: ["*", 25, 70, 20, 40],
      headerRows: 0,
      keepWithHeaderRows: 0,
      body: [
        [
          {
            text: "Anzahl der Zimmer",
            style: "tableTextBold",
            colSpan: 2,
            border: noBorder,
          },
          { text: "", border: noBorder },
          { text: "", border: noBorder },
          { text: "", border: noBorder },
          {
            text: "",
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
        ],
        [
          {
            text: "Summe der Miet-/ Beschäftigungstage / Gesamtzahl",
            style: "tableTextBold",
            colSpan: 2,
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "Tage",
            alignment: "center",
            style: "tableTextBold",
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "" + anzahlBeschaeftigungstageSteuerpflichtig,
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
        ],
        [
          {
            text: "Anzahl der Tage ohne Umsatz",
            style: "tableText2",
            colSpan: 2,
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "Tage",
            alignment: "center",
            style: "tableText2",
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "",
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
        ],
        [
          {
            text:
              "Gesamtzahl der Miet-/ Tätigkeitstage aller Personen\nSeite 2 bis Seite ____",
            style: "tableTextBold",
            colSpan: 2,
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "Tage",
            alignment: "center",
            style: "tableTextBold",
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "" + anzahlBeschaeftigungstage,
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
        ],
        [
          {
            text: "Gesamtzahl der Miet-/ Tätigkeitstage",
            style: "tableTextBold",
            border: noBorder,
          },
          {
            text: "" + anzahlBeschaeftigungstageSteuerpflichtig,
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
          {
            text: "x 25,00 Euro",
            alignment: "center",
            style: "tableTextBold",
            border: noBorder,
          },
          {
            text: "=",
            alignment: "center",
            style: "tableTextBold",
            border: noBorder,
          },
          {
            text: gesamtSteuer,
            alignment: "center",
            style: "tableText2",
            border: borderBottom,
          },
        ],
      ],
    },
  },
  {
    layout: "dottedBorders",
    margin: [0, 30, 20, 5],
    table: {
      widths: ["*", 65, 3, 40],
      headerRows: 0,
      keepWithHeaderRows: 0,
      body: [
        [
          {
            text: "Zahlungsbetrag:",
            style: "tableTextBold",
            border: noBorder,
          },
          {
            text: gesamtSteuer,
            style: "tableText2",
            alignment: "center",
            border: borderBottom,
          },
          { text: "", border: noBorder },
          {
            text: "Euro",
            style: "tableTextBold",
            alignment: "center",
            border: noBorder,
          },
        ],
      ],
    },
  },
  {
    layout: "signatures",
    margin: [0, 54, 20, 5],
    table: {
      widths: [115, 70, 190, "*"],
      headerRows: 0,
      keepWithHeaderRows: 0,
      body: [
        [
          {
            text: "",
            style: "tableTextBold",
            border: borderBottom,
          },
          { text: "", border: noBorder },
          {
            text: "",
            /*
            image: "unterschriftZNA",
            fit: [110, 30],
            */
            alignment: "center",
            border: borderBottom,
          },
          { text: "", border: noBorder },
        ],
        [
          {
            text: "(Ort, Datum)",
            style: "smaller",
            alignment: "center",
            border: noBorder,
          },
          { text: "", border: noBorder },
          {
            text: "Unterschrift Betreiber/in bzw. Bevollmächtigte/r",
            style: "smaller",
            alignment: "center",
            border: noBorder,
          },
          { text: "", border: noBorder },
        ],
      ],
    },
  },
];};

export { createDeckblattContent };
